"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withIcon;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function withIcon(name) {
  return WrappedComponent => {
    return function (props) {
      const theme = (0, _react2.useTheme)();
      const defaultProps = {
        accessibilityLabel: props.accessibilityLabel ? props.accessibilityLabel : undefined,
        decorative: props.decorative ? props.decorative : undefined,
        color: props.color ? props.color : '#000',
        flip: props.flip ? props.flip : false,
        flipVertical: props.flipVertical ? props.flipVertical : false,
        inline: props.inline ? props.inline : false,
        size: props.size ? props.size : '24px',
        primary: props.primary ? props.primary : false,
        secondary: props.secondary ? props.secondary : false
      };
      const {
        accessibilityLabel,
        color,
        decorative,
        flip,
        flipVertical,
        inline,
        size,
        primary,
        secondary
      } = defaultProps;
      const backgroundedStyles = {
        backgroundColor: theme.primary10opa,
        borderRadius: '50%'
      };
      const newProps = {
        focusable: 'false',
        role: decorative ? 'presentation' : 'img',
        style: {
          height: size,
          width: size,
          display: inline ? 'inline' : 'block',
          fill: primary ? theme.primary : secondary ? theme.secondary : color,
          transform: flip || flipVertical ? `scale(${flip ? -1 : 1}, ${flipVertical ? -1 : 1})` : 'scale(1)',
          // keep scale(1) for transition flipping
          transition: 'transform 300ms ease-out',
          ...(props.backgrounded && backgroundedStyles)
        }
      };
      if (accessibilityLabel) {
        newProps['aria-label'] = accessibilityLabel;
      } else {
        newProps['aria-hidden'] = true;
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(WrappedComponent, {
        ...newProps
      });
    };
  };
}